/** Matches `RegistrationsDataSource.bulkOperationChildAction` (never returns `all`). */
export type BulkChildAction = 'parent' | 'include' | 'exclude'

export function resolveBulkChildIds(action: BulkChildAction, currentParentId: string, selectedChildIds: string[], excludedChildIds: string[]): string[] {
  if (action === 'parent') {
    return currentParentId ? [currentParentId] : []
  }
  if (action === 'include') {
    return selectedChildIds
  }
  return excludedChildIds
}

export function countBulkChildSelection(action: BulkChildAction, childDataLength: number, selectedCount: number, excludedIdCount: number): number {
  if (action === 'parent') {
    return childDataLength
  }
  if (action === 'include') {
    return selectedCount
  }
  return Math.max(0, childDataLength - excludedIdCount)
}
